import React from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey, getWarnList } from '../utils';

/**
 * Risk 渲染器 - 风险/鉴伪结果展示
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const RiskRenderer = ({ params, config, selectRect, onSelect }) => {
  const riskList = getWarnList(params);

  if (riskList.length === 0) {
    return <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未检测到待告警信息</div>;
  }

  return (
    <>
      <Form.Item label="">鉴伪结果：</Form.Item>
      {riskList.map((item, index) => {
        const selectRectVal = getSelectRectKey({
          data: item,
          key: '',
          valStr: `${item.key}-${item[config.riskNum]}`
        });
        const warnInfo = config.warnsList?.[item.key];

        return (
          <Form.Item
            key={`risk-${index}`}
            active
            label={`${index + 1}、风险程度-${warnInfo?.warnTitle || item.key}`}
            className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
            onClick={() => {
              onSelect && onSelect(item.key, selectRectVal);
            }}
          >
            <p className="mb-10">
              <span>{item[config.riskNum]}{warnInfo?.tips ? `,${warnInfo.tips}` : ''}</span>
            </p>
          </Form.Item>
        );
      })}
    </>
  );
};

export default RiskRenderer;
